import { useEffect, useRef } from 'react';
import './NodeBreadcrumbs.css';

export default function NodeBreadcrumbs({ path, onNavigate, isDarkMode }) {
  const trailRef = useRef(null);
  const currentId = path[path.length - 1]?.id;
  useEffect(() => {
    if (trailRef.current) trailRef.current.scrollLeft = trailRef.current.scrollWidth;
  }, [currentId]);
  if (!path.length) return null;
  return (
    <nav ref={trailRef} aria-label="Selected idea breadcrumbs"
      className="top-bar__breadcrumbs" data-dark={isDarkMode ? 'true' : 'false'}
      data-viewport-occlusion="true" data-export-ignore="true"
      onKeyDown={(event) => event.stopPropagation()}>
      <ol>
        {path.map((node, index) => (
          <li key={node.id}>
            {index > 0 && <span aria-hidden="true">›</span>}
            <button type="button" title={node.text}
              aria-current={index === path.length - 1 ? 'location' : undefined}
              onClick={() => onNavigate?.(node.id)}>{node.text}</button>
          </li>
        ))}
      </ol>
    </nav>
  );
}
